const posthogKey = import.meta.env.VITE_POSTHOG_KEY?.trim();
const posthogHost = import.meta.env.VITE_POSTHOG_HOST?.trim() || "https://app.posthog.com";
let posthogPromise: Promise<typeof import("posthog-js").default | null> | null = null;
let posthogClient: typeof import("posthog-js").default | null = null;
let analyticsConsentGranted = false;
let pendingProductUser: {
  id: string;
  role?: string | null;
  plan?: string | null;
} | null = null;

function isAnalyticsEnabled() {
  return Boolean(posthogKey);
}

async function loadPosthog() {
  if (!isAnalyticsEnabled()) return null;
  if (posthogClient) return posthogClient;
  if (!posthogPromise) {
    posthogPromise = import("posthog-js")
      .then(({ default: posthog }) => {
        posthog.init(posthogKey!, {
          api_host: posthogHost,
          capture_pageview: false,
          capture_pageleave: true,
          autocapture: false,
          persistence: "memory",
        });
        posthogClient = posthog;
        return posthog;
      })
      .catch((error) => {
        console.warn("PostHog failed to load lazily", error);
        return null;
      });
  }

  return posthogPromise;
}

export function initProductAnalytics() {
  // Mantemos o bootstrap leve e carregamos o SDK apenas depois do consentimento de analytics.
}

export function configureProductAnalyticsConsent(allowed: boolean) {
  if (!isAnalyticsEnabled()) return;

  analyticsConsentGranted = allowed;

  if (!allowed) {
    if (posthogClient) {
      posthogClient.reset();
    }
    return;
  }

  void loadPosthog().then((posthog) => {
    if (!posthog || !pendingProductUser) return;

    posthog.identify(pendingProductUser.id, {
      role: pendingProductUser.role ?? undefined,
      plan: pendingProductUser.plan ?? undefined,
    });
  });
}

export function captureProductEvent(event: string, properties: Record<string, unknown> = {}) {
  if (!isAnalyticsEnabled() || !analyticsConsentGranted) return;
  void loadPosthog().then((posthog) => {
    posthog?.capture(event, properties);
  });
}

export function identifyProductUser(input: {
  id: string;
  role?: string | null;
  plan?: string | null;
}) {
  if (!isAnalyticsEnabled()) return;
  pendingProductUser = input;
  if (!analyticsConsentGranted) return;

  void loadPosthog().then((posthog) => {
    posthog?.identify(input.id, {
      role: input.role ?? undefined,
      plan: input.plan ?? undefined,
    });
  });
}

export function resetProductUser() {
  if (!isAnalyticsEnabled()) return;
  pendingProductUser = null;
  posthogClient?.reset();
}
